import React, {useState} from "react"
import ListComponent from "../../UI/ListComponent/ListComponent"
import { get } from "../../../helpers/utils"
import PropTypes from "prop-types"
import * as styles from "./Footer-tw-styles"
import SocialLinks from "../../UI/SocialLinks/SocialLinks"
import Typography from "../../UI/Typography/Typography"
import { labels, jumpToFooter } from "../../../constants/label.constants"
import useScreenSize from "../../../hooks/useScreenSize"
import Image from "../../UI/Image/Image"
import useScroll from "../../../hooks/useScroll"
import Link from "../../UI/Link/Link"

const Footer = props => {
  const {
    note,
    mainLinksCollection,
    socialLinksCollection,
    hideFooter,
    secondaryLinksCollection,
    slug,
    upliftButton
  } = props
  const style = styles.defaultStyle
  const {
    footerlinsMob,
    FooterHead,
    bottomSideFooter,
    bottomFooter,
    bottomFooter2,
    Social,
    footerWrap,
    fatFooter,
    copyrightContainer,
    SocialLinkWrapper,
    SocialLinkLeft,
  } = style
  const scroll = useScroll(labels.footer.scrollHeight);
  const screenSize = useScreenSize();

  const mainLinks = mainLinksCollection && get(mainLinksCollection, "items", [])
  const socialLinks =
    socialLinksCollection && get(socialLinksCollection, "items", [])
  const secondaryLinks =
    secondaryLinksCollection && get(secondaryLinksCollection, "items", [])
    const [showLogo, setShowLogo] = useState(false)

  return (
    <>
      <div className={footerlinsMob} role="contentinfo" id={jumpToFooter}>
      {!hideFooter && <>
      {note && <Typography content={note} className={FooterHead} />}

        {/* Footer main content  */}
        <div className={footerWrap}>
        {(slug?.includes('/India/India-Business/snacking-made-right') || slug?.includes('/India/India-Business/cocoa-life')|| slug?.includes('/India/India-Business/community-initiatives/')) && <Image src="https://images.ctfassets.net/zo243s55pyir/5ITc0geqUzyr28A7x1SJZ7/00b33ef1c985412c982849c2218814f0/image_139.png" />}
          <div className={fatFooter}>
            {mainLinks?.length &&
              mainLinks?.map((link, index) => {
                const linksCollection = get(link, "linksCollection.items", [])
                const links =
                  linksCollection.length == 0 ? link?.links : linksCollection
                return (
                  <div className={Social} key={`${link?.title}`}>
                    <ListComponent
                      linksCollection={links}
                      label={link?.title}
                      variant={"footerMainLinks"}
                    />
                  </div>
                )
              })}
          </div>
        </div>
        
        {screenSize?.isMobile && scroll.isScrolled && upliftButton && 
            <div className={style?.upliftBtnMobile}>
              <Link {...upliftButton} />
            </div>
        }

        {screenSize?.isTablet && scroll.isScrolled &&  upliftButton && 
            <div className={style?.upliftBtnTablet}>
              <Link {...upliftButton} />
            </div>
        }

        <div className={SocialLinkWrapper}>
          <div className={SocialLinkLeft}></div>
          {/* social link component  */}
          {socialLinks && (
            <SocialLinks socialLinks={socialLinks} variant={"socialLinks"} />
          )}
        </div>

        {/* site copyRight text */}
        <div className={bottomFooter}>
          <div className={bottomFooter2}>
            <div className={copyrightContainer}>
              <span className="">
                &copy;
                {labels?.footer?.copyRight?.text1}
              </span>
              {screenSize?.isDesktop && <span>{`. `} </span>}
              <span className="">
                {labels?.footer?.copyRight?.text2}
                {`.`}
              </span>
            </div>
          </div>

          <div className={bottomSideFooter}>
            {secondaryLinks?.length > 0 &&
              secondaryLinks?.map((link, index) => {
                const secLinksCollection = get(
                  link,
                  "linksCollection.items",
                  []
                )
                return (
                  <div key={`${link?.title}`}>
                    <ListComponent
                      linksCollection={secLinksCollection}
                      label={link?.title}
                      variant={"footerSecondaryLinks"}
                      key={index}
                    />
                  </div>
                )
              })}
          </div>
          {screenSize?.isDesktop && scroll.isScrolled && upliftButton && (
        <div className={style?.upliftBtn}>
          <Link {...upliftButton} />
        </div>
      )}
        </div></>}
      </div>
    </>
  )
}

Footer.propTypes = {
  note: PropTypes.string,
  mainLinksCollection: PropTypes.object,
  socialLinksCollection: PropTypes.object,
  secondaryLinksCollection: PropTypes.object,
  hideFooter: PropTypes.bool,
  slug: PropTypes.any,
  upliftButton : PropTypes.object
}

export default Footer
